import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteSettings } from '../SiteSettingsContext';
import { giftFinderLinkLabel, isGiftFinderLinkVisible } from './giftFinderSettings';

/**
 * Renders a link to /gift-finder when enabled for the given placement, otherwise nothing.
 * @param {'home'|'shop'|'nav'|'footer'} placement
 */
export default function GiftFinderLink({ placement, className, children, ...rest }) {
  const { settings } = useSiteSettings();
  const storeCopy = settings?.store_copy;

  if (!isGiftFinderLinkVisible(storeCopy, placement)) {
    return null;
  }

  const label = children ?? giftFinderLinkLabel(storeCopy, placement);

  return (
    <Link to="/gift-finder" className={className} {...rest}>
      {label}
    </Link>
  );
}
